const EcmoEmrActions = {
    SEARCH: "ecmoemr/search",
    SEARCH_RESULT: "ecmoemr/search-result",
    SEARCH_ERROR: "ecmoemr/search-error",
};

export default EcmoEmrActions;



// WEBPACK FOOTER //
// ./app/data/EcmoEmrActions.js